export const _p = async <T>(a: T) => a;

export const _p2 = async <T>(a: T, fn: (a: T) => Promise<void>) => {
  await fn(a);
  return a;
};

export const _t = async <T = void>(_: T) => {
  return;
};
